module.exports = __webpack_public_path__ + "img/triangle.56f40953.svg";